import React, { useEffect, useState, useRef } from "react";
import { Popup } from "zarm";
import classnames from "classnames";
import { Icon } from "@iyunbao/components";
import { tools } from '@iyunbao/utils';
import { getAddressOptions } from "./util";
import { SearchProps, addressListProps } from "./type";
import LockScroll from '../../lockScroll';


function SearchPopup(props: SearchProps) {
  const prefixCls = "address-popup";
  const { visible = false, onBack, onOk } = props;

  const [showEmpty, setShowEmpty] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState<addressListProps[]>([]);
  const searchRef = useRef<HTMLInputElement | null>(null);


  // 打开弹框时直接获获取焦点
  useEffect(
    () => {
      if (!tools.isIOS) {
        if (visible && searchRef.current) {
          searchRef.current.focus();
        }
      }
    },
    [visible]
  );

  // 清空输入框 获取焦点
  const handleClearInput = () => {
    setSearchValue("");
    setSearchResult([]);
    setShowEmpty(false);
    if (visible && searchRef.current) {
      searchRef.current.focus();
    }
  };

  // 选中点击
  const handleOk = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    onOk(value);
    const timer = setTimeout(() => {
      clearTimeout(timer);
      handleClearInput();
    }, 300);
  };

  // 搜索框值变化
  const handleSearchChange = e => {
    setSearchValue(e.target.value);
  };

  // 返回按钮
  const handleBack = e => {
    e.preventDefault();
    e.stopPropagation();
    onBack();
    setSearchValue("");
    setSearchResult([]);
    setShowEmpty(false);
  };

  // 点击搜索按钮查询数据
  const handleSearch = () => {
    getAddressOptions(props, searchValue, (list: any) => {
      setSearchResult(list);
      setShowEmpty(true);
    });
  };

  const renderSearchResult = () => {
    return (
      <div className={`${prefixCls}-search-wrapper-result`}>
        {searchResult.map(item => {
          return (
            <div
              className={`${prefixCls}-search-result-item`}
              key={`${item.address}${item.name}`}
              onClick={e => handleOk(e, item.address)}
            >
              <div className={`${prefixCls}-search-result-item-title`}>{item.name}</div>
              <div className={`${prefixCls}-search-result-item-desc`}>{item.address}</div>
            </div>
          );
        })}
        {showEmpty && (
          <div className={`${prefixCls}-search-result-empty`}>
            <div className={`${prefixCls}-search-result-empty-ask`}>找不到地址?</div>
            <div>请尝试只输入小区、写字楼或学校名，</div>
            <div>详情地址（如门牌号）可稍后输入哦。</div>
          </div>
        )}
      </div>
    );
  };

  const renderSearchWrapper = () => {
    return (
      <div className={`${prefixCls}-search-wrapper`}>
        <div className={`${prefixCls}-search-wrapper-header`}>
          <div className={`${prefixCls}-back-icon`} onClick={handleBack}>
            <Icon type="zuo" />
          </div>
          <div className={`${prefixCls}-search-box`}>
            <Icon type="sousuo" />
            <input type="text" value={searchValue} ref={searchRef} placeholder="请输入" onChange={handleSearchChange} />
            <span>
              <Icon
                type="guanbi_"
                style={{ opacity: searchValue.length ? 1 : 0 }}
                className="clean-input"
                onClick={handleClearInput}
              />
            </span>
          </div>
          <div className={`${prefixCls}-search-btn`} onClick={handleSearch}>
            搜索
          </div>
        </div>
        {renderSearchResult()}
      </div>
    );
  };

  const cls = classnames(`${prefixCls}-bottom-wrapper`, {
    [`${prefixCls}-show-search-wrapper`]: true
  });

  return (
    <LockScroll>
      <Popup className="address-popup" visible={visible} direction="bottom" destroy={false} mountContainer={() => document.body}>
        <div className={cls} style={{ height: "75vh", background: "#fff" }}>
          {renderSearchWrapper()}
        </div>
      </Popup>
    </LockScroll>

  );
}

export default SearchPopup;
